import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getOrderList(filters, showLoader) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/orders/',
      method: HttpMethod.GET
    };
    try {
      const res = await processRequest(ep, { params: filters }, showLoader);
      const {
        items,
        total,
        countUnclaimed,
        countPending,
        countContact,
        countQuoted,
        countAppointment
      } = processSuccessResponse(res);

      return { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment };
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateStage(id, payload) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/orders/${id}/`,
      method: HttpMethod.PATCH
    };
    try {
      const res = await processRequest(ep, { data: payload });
      const item = processSuccessResponse(res);

      return { item };
    }catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getOrderNotes(orderId) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/order-notes/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          orderId,
          pageSize: -1
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addOrderNotes(orderId, content) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/order-notes/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {
        data: {
          orderId,
          content
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getMyOrderList(filters, showLoader) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/my-orders/',
      method: HttpMethod.GET
    };
    try {
      const res = await processRequest(ep, { params: filters }, showLoader);
      const {
        items,
        total,
        countUnclaimed,
        countPending,
        countContact,
        countQuoted,
        countAppointment
      } = processSuccessResponse(res);

      return { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment };
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createAssetOrder(payload) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/assets/',
      method: HttpMethod.POST
    };
    try {
      const res = await processRequest(ep, { data: payload });

      const item = processSuccessResponse(res);

      return item;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateAssetOrder(id, payload) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/assets/${id}/`,
      method: HttpMethod.PATCH
    };
    try {
      const res = await processRequest(ep, { data: payload });
      const item = processSuccessResponse(res);

      return { item };
    }catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createOrder(payload) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/orders/',
      method: HttpMethod.POST
    };
    try {
      const res = await processRequest(ep, { data: payload });
      const item = processSuccessResponse(res);

      return { item };
    }catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientByPhoneNumber(phoneNumber) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/phone-${phoneNumber}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const client = processSuccessResponse(res);

      return client;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async setWorkingAgent(orderId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/orders/${orderId}/working-agent/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {}, false);
      processSuccessResponse(res);
      return true;
    } catch(e) {
      return false;
    }
  },

  async removeWorkingAgent(orderId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/orders/${orderId}/working-agent/`,
      method: HttpMethod.DELETE
    };

    try {
      const res = await processRequest(ep, {}, false);
      processSuccessResponse(res);
      return true;
    } catch(e) {
      return false;
    }
  },

  async getOrderById(orderId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/orders/${orderId}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const items = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
